const codes = [
    30207, // 已评
    20159, // 查不到用户任务错误
];

const alertHasCode = (code) => {
    const result = codes.join(',').indexOf(code) > -1;
    return result;
};

export { alertHasCode as default };
